import './bootstrap';
import anime from 'animejs';
import * as basicLightbox from 'basiclightbox';
import {containRetinaImages, mapbox, marquee, masonryLayout} from '../shared/helpers';
import '../shared/components/jobsite/alpine/index';
import '../shared/add-to-calendar.css';
// import ScrollMagic from 'scrollmagic';

//Make it possible to show add to calendar buttons
require('../shared/add-to-calendar');
import '../shared/add-to-calendar.css';

// import cookie functions
require('../shared/cookies');

// Load in the right form
if (typeof interviewInvitationResource !== 'undefined' && interviewInvitationResource) {
    require('./interview-form');
} else {
    require('./application-form');
}

document.querySelectorAll('.masonry-grid').forEach(item => {
    masonryLayout(item);
});

document.querySelectorAll('.marquee-slider').forEach(item => {
    marquee(item);
});

document.querySelectorAll('.locations').forEach(item => {
    mapbox(item);
});

document.querySelectorAll('.perk-container').forEach(item => {
    containRetinaImages(item);
});

let controller = new ScrollMagic.Controller();

let menu = document.getElementById('site__header');
let heroBanner = document.getElementById('hero-banner');
if (heroBanner) {
    let parallaxHeroImage = anime({
        targets: heroBanner.querySelector('div'),
        translateY: heroBanner.offsetHeight * 0.5,
        easing: 'cubicBezier(.25, 0, 1, 1)',
        autoplay: false,
    });

    new ScrollMagic.Scene({
        triggerElement: menu,
        triggerHook: 'onLeave',
        duration: menu.offsetHeight + heroBanner.offsetHeight,
    })
        .addTo(controller)
        .on('progress', event => {
            parallaxHeroImage.seek(parallaxHeroImage.duration * event.progress);
        });
}

let scrollTargets = document.querySelectorAll('.scroll-scene');

for (let i = 0; i < scrollTargets.length; i++) {

    // We don't need to trigger the animation for header and footer elements.
    if (i === 0 || i === (scrollTargets.length - 1)) {
        continue;
    }

    let header = scrollTargets[i].querySelector('.scroll-scene__header');

    if (!header) {
        continue;
    }

    let revealHeader = anime({
        targets: header,
        keyframes: [
            {
                duration: 0,
                translateY: 50,
                opacity: 0,
            },
            {
                duration: 500,
                translateY: 0,
                opacity: 1,
            },
        ],
        easing: 'easeInOutQuad',
        autoplay: false,
        complete(anim) {

        },
    });

    new ScrollMagic.Scene({
        triggerElement: scrollTargets[i],
        triggerHook: 0.8,
    })
        .addTo(controller)
        .on('enter', event => {
            revealHeader.play();
            event.target.destroy();
        });
}

// video play ?
document.querySelectorAll('[data-popup="video"]')
    .forEach(item => {
        item.querySelector('.trigger').addEventListener('click', function (event) {
            event.preventDefault();

            // validate
            if (item.querySelector('.hidden')) {
                // if item does not exist already, create it
                if (typeof item.lightbox == 'undefined') {
                    item.lightbox = basicLightbox.create(
                        item.querySelector('.hidden'),
                    );
                }

                // show
                item.lightbox.show();
            }
        });
    });

// Gallery popup ?
document.addEventListener("DOMContentLoaded", function (event) {
    // Your code to run since DOM is loaded and ready
    document.querySelectorAll('[data-popup="gallery"]').forEach(item => {
        item.addEventListener('click', function (event) {
            event.preventDefault();

            // if item does not exist already, create it
            if (typeof item.lightbox == 'undefined') {
                item.lightbox = basicLightbox.create('<img src="' + item.getAttribute('src').replace(/\?.*/, '') + '">');
            }

            // show
            item.lightbox.show();
        });
    });
});
